/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  GenericTableData
} from '../../model/genericTableData'
import type {
  HypotheticalTransactionCodeData
} from '../../model/hypotheticalTransactionCodeData'
import type {
  HypotheticalWaterfallAPICreateDataRequest
} from '../../model/hypotheticalWaterfallAPICreateDataRequest'
import type {
  HypotheticalWaterfallCategoriesRetrieveParams
} from '../../model/hypotheticalWaterfallCategoriesRetrieveParams'
import type {
  HypotheticalWaterfallData
} from '../../model/hypotheticalWaterfallData'
import type {
  LpBreakdownReportResponse
} from '../../model/lpBreakdownReportResponse'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Creates a hypothetical waterfall
 */
export const hypotheticalWaterfallCreate = (
    fundFamilyId: string,
    hypotheticalWaterfallAPICreateDataRequest: HypotheticalWaterfallAPICreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<HypotheticalWaterfallData>(
      {url: `/fund-family/${fundFamilyId}/hypothetical-waterfall/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: hypotheticalWaterfallAPICreateDataRequest
    },
      options);
    }
  


export const getHypotheticalWaterfallCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hypotheticalWaterfallCreate>>, TError,{fundFamilyId: string;data: HypotheticalWaterfallAPICreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof hypotheticalWaterfallCreate>>, TError,{fundFamilyId: string;data: HypotheticalWaterfallAPICreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hypotheticalWaterfallCreate>>, {fundFamilyId: string;data: HypotheticalWaterfallAPICreateDataRequest}> = (props) => {
          const {fundFamilyId,data} = props ?? {};

          return  hypotheticalWaterfallCreate(fundFamilyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HypotheticalWaterfallCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallCreate>>>
    export type HypotheticalWaterfallCreateMutationBody = HypotheticalWaterfallAPICreateDataRequest
    export type HypotheticalWaterfallCreateMutationError = unknown

    export const useHypotheticalWaterfallCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hypotheticalWaterfallCreate>>, TError,{fundFamilyId: string;data: HypotheticalWaterfallAPICreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getHypotheticalWaterfallCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Tables representing LP by LP report of hypothetical waterfalls
 */
export const lpBreakdownTableRetrieve = (
    fundFamilyId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<LpBreakdownReportResponse>(
      {url: `/fund-family/${fundFamilyId}/hypothetical-waterfall/lp-by-lp-reports`, method: 'GET', signal
    },
      options);
    }
  

export const getLpBreakdownTableRetrieveQueryKey = (fundFamilyId: string,) => {
    return [`/fund-family/${fundFamilyId}/hypothetical-waterfall/lp-by-lp-reports`] as const;
    }

    
export const getLpBreakdownTableRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof lpBreakdownTableRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lpBreakdownTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLpBreakdownTableRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof lpBreakdownTableRetrieve>>> = ({ signal }) => lpBreakdownTableRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lpBreakdownTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type LpBreakdownTableRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof lpBreakdownTableRetrieve>>>
export type LpBreakdownTableRetrieveQueryError = unknown

export const useLpBreakdownTableRetrieve = <TData = Awaited<ReturnType<typeof lpBreakdownTableRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lpBreakdownTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getLpBreakdownTableRetrieveQueryOptions(fundFamilyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getLpBreakdownTableRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof lpBreakdownTableRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof lpBreakdownTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLpBreakdownTableRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof lpBreakdownTableRetrieve>>> = ({ signal }) => lpBreakdownTableRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof lpBreakdownTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type LpBreakdownTableRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof lpBreakdownTableRetrieve>>>
export type LpBreakdownTableRetrieveSuspenseQueryError = unknown

export const useLpBreakdownTableRetrieveSuspense = <TData = Awaited<ReturnType<typeof lpBreakdownTableRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof lpBreakdownTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getLpBreakdownTableRetrieveSuspenseQueryOptions(fundFamilyId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getLpBreakdownTableRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getLpBreakdownTableRetrieveQueryKey(fundFamilyId),
              queryFn: () => lpBreakdownTableRetrieve(fundFamilyId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Table Data representing status of hypo waterfalls in the system
 */
export const hypotheticalWaterfallOverviewRetrieve = (
    fundFamilyId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/hypothetical-waterfall/overview`, method: 'GET', signal
    },
      options);
    }
  

export const getHypotheticalWaterfallOverviewRetrieveQueryKey = (fundFamilyId: string,) => {
    return [`/fund-family/${fundFamilyId}/hypothetical-waterfall/overview`] as const;
    }

    
export const getHypotheticalWaterfallOverviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallOverviewRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallOverviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallOverviewRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallOverviewRetrieve>>> = ({ signal }) => hypotheticalWaterfallOverviewRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallOverviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallOverviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallOverviewRetrieve>>>
export type HypotheticalWaterfallOverviewRetrieveQueryError = unknown

export const useHypotheticalWaterfallOverviewRetrieve = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallOverviewRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallOverviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallOverviewRetrieveQueryOptions(fundFamilyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getHypotheticalWaterfallOverviewRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallOverviewRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallOverviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallOverviewRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallOverviewRetrieve>>> = ({ signal }) => hypotheticalWaterfallOverviewRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallOverviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallOverviewRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallOverviewRetrieve>>>
export type HypotheticalWaterfallOverviewRetrieveSuspenseQueryError = unknown

export const useHypotheticalWaterfallOverviewRetrieveSuspense = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallOverviewRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallOverviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallOverviewRetrieveSuspenseQueryOptions(fundFamilyId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getHypotheticalWaterfallOverviewRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getHypotheticalWaterfallOverviewRetrieveQueryKey(fundFamilyId),
              queryFn: () => hypotheticalWaterfallOverviewRetrieve(fundFamilyId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets all hypothetical tx codes needed for a waterfall and the allocation
 */
export const hypotheticalWaterfallCategoriesRetrieve = (
    fundFamilyId: string,
    params: HypotheticalWaterfallCategoriesRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<HypotheticalTransactionCodeData>(
      {url: `/fund-family/${fundFamilyId}/hypothetical-waterfall/transaction-codes`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getHypotheticalWaterfallCategoriesRetrieveQueryKey = (fundFamilyId: string,
    params: HypotheticalWaterfallCategoriesRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/hypothetical-waterfall/transaction-codes`, ...(params ? [params]: [])] as const;
    }

    
export const getHypotheticalWaterfallCategoriesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallCategoriesRetrieve>>, TError = unknown>(fundFamilyId: string,
    params: HypotheticalWaterfallCategoriesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallCategoriesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallCategoriesRetrieveQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallCategoriesRetrieve>>> = ({ signal }) => hypotheticalWaterfallCategoriesRetrieve(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallCategoriesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallCategoriesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallCategoriesRetrieve>>>
export type HypotheticalWaterfallCategoriesRetrieveQueryError = unknown

export const useHypotheticalWaterfallCategoriesRetrieve = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallCategoriesRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    params: HypotheticalWaterfallCategoriesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallCategoriesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallCategoriesRetrieveQueryOptions(fundFamilyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getHypotheticalWaterfallCategoriesRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallCategoriesRetrieve>>, TError = unknown>(fundFamilyId: string,
    params: HypotheticalWaterfallCategoriesRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallCategoriesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallCategoriesRetrieveQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallCategoriesRetrieve>>> = ({ signal }) => hypotheticalWaterfallCategoriesRetrieve(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallCategoriesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallCategoriesRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallCategoriesRetrieve>>>
export type HypotheticalWaterfallCategoriesRetrieveSuspenseQueryError = unknown

export const useHypotheticalWaterfallCategoriesRetrieveSuspense = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallCategoriesRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    params: HypotheticalWaterfallCategoriesRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallCategoriesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallCategoriesRetrieveSuspenseQueryOptions(fundFamilyId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getHypotheticalWaterfallCategoriesRetrieveLoader = (queryParamsOrFn: (HypotheticalWaterfallCategoriesRetrieveParams | ((params: Params) => HypotheticalWaterfallCategoriesRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getHypotheticalWaterfallCategoriesRetrieveQueryKey(fundFamilyId, queryParams),
              queryFn: () => hypotheticalWaterfallCategoriesRetrieve(fundFamilyId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      